import {IPresentation} from '../../../../../incase-domain/presentation';

export const mapPresentationDataToOptions = (presentationData: IPresentation[]): {value: string; label: string}[] => {
    return presentationData.map((presentation) => ({
        value: presentation._id,
        label: presentation.name || '',
    }));
};
